import React from 'react';
import PropTypes from 'prop-types';

export const filterBy = {
  ALL: 0,
  PORT: 1,
  TOKEN: 2,
};

class DestinationFilter extends React.Component {
  static propTypes = {
    portCount: PropTypes.number.isRequired,
    tokenCount: PropTypes.number.isRequired,
    onFilterChange: PropTypes.func.isRequired
  };

  state = {
    selected: filterBy.ALL
  };

  onFilter = (e) => {
    const selected = e.currentTarget.value;

    this.setState({ selected }, this.props.onFilterChange(selected));
  }

  render() {
    const { portCount, tokenCount } = this.props;
    const allCount = portCount + tokenCount;
    const { selected } = this.state;

    return (
      <div className="destinations-filter">
        <div className="grid flex">
          <p className="grid-cell">
            <label>
              <input type="radio" name="filter" onChange={this.onFilter} value={filterBy.ALL} defaultChecked={selected === filterBy.ALL} />
              All <span>({allCount})</span>
            </label>
          </p>
          <p className="grid-cell">
            <label>
              <input type="radio" name="filter" onChange={this.onFilter} value={filterBy.TOKEN} defaultChecked={selected === filterBy.TOKEN} />
              Token <span>({tokenCount})</span>
            </label>
          </p>
          <p className="grid-cell">
            <label>
              <input type="radio" name="filter" onChange={this.onFilter} value={filterBy.PORT} defaultChecked={selected === filterBy.PORT} />
              Port <span>({portCount})</span>
            </label>
          </p>
        </div>
      </div>
    );
  }
};

export default DestinationFilter;
